import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import Typography from 'material-ui/Typography'
import Icon from 'material-ui/Icon'
import IconButton from 'material-ui/IconButton'
import Button from 'material-ui/Button'
import { withStyles } from 'material-ui/styles'
import styles from './styles'

import {
  userImpersonateStop,
  setAuthToken,
  setProfile,
  userGet,
  resetReducersOnImpersonate
} from '../../redux/actions'
import {getAppSetting} from '../../redux/actions/appSettingActions'

import history from '../../history'


import Auth from '../../auth'
const auth = new Auth()

class ImpersonationBar extends React.Component {

  render() {
    const {
      classes,
      translate,
      impersonating,
      impersonatedUser,
      stopImpersonating
    } = this.props

    return (
      (impersonating) ? (
        <AppBar position="fixed" style={{ background: '#D42E4C' }} id="impersonate">
          <div className={classes.centred}>
            <Toolbar>
              <IconButton color="inherit">
                <Icon>warning</Icon>
              </IconButton>
              <Typography type="title" className={classes.flex} color="inherit">
                {translate("general_impersonating")} <strong>{impersonatedUser.impersonatedname} ({impersonatedUser.impersonatedcustomer})</strong>
              </Typography>
              <Button className={classes.button} mini onClick={() => stopImpersonating(impersonatedUser)}>
                <Icon>close</Icon>
              </Button>
            </Toolbar>
          </div>
        </AppBar>
      ) : (
          null
        )
    )
  }
}

const mapStateToProps = (state) => ({
  impersonating: state.userReducer.impersonating,
  impersonatedUser: state.userReducer.impersonatedUser,
  ...state,
})

const mapDispatchToProps = (dispatch, props) => ({
  stopImpersonating: () => {
    dispatch(userImpersonateStop()).then((response) => {
      const data = response.payload.data
      const { access_token, refresh_token, customer, name, roles, rolenames, id, customerid } = data

      let expires = (new Date(response.payload.data['.expires'])).getTime()
      dispatch(setAuthToken({
        access_token,
        refresh_token,
        expires
      }))

      auth.handleAuthentication({
        access_token,
        refresh_token,
        expires
      })

      dispatch(setProfile({
        roles: roles,
        rolenames: rolenames,
        customer: customer,
        name: name,
        id: id,
        customerid: customerid,
      }))
      dispatch(userGet(id))

      history.replace('/organisations', true)
      dispatch(resetReducersOnImpersonate())
      dispatch(getAppSetting({ force: true }))

    })
  }
})

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(ImpersonationBar);
